import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class aboutItme extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />

                <main className="main-area fix">
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <canvas id="can" />
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                About ITME 2026
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="about_section">
                        <div className="container">
                            <div className="row">
                                <div
                                    className="col-lg-6 col-sm-6"
                                    data-aos="fade-right"
                                    data-aos-delay={300}
                                >
                                    <div className="about-content">
                                        {/* <h4 class="border_title">About</h4> */}
                                        <div className="selector">
                                            <h2 className="ah-headline letters rotate-3">
                                                <span>INDIA ITME 2026</span>
                                            </h2>
                                        </div>
                                        <p>
                                            India ITME 2026 shall be held in India Exposition Mart Ltd, Noida.
                                            The total number of halls will be 15 with a total area of 2,35,000
                                            sq. mtrs, making it the largest in this industry segment.
                                        </p>
                                        <p>
                                            This event is expected to host more than 1800 exhibitors in 20
                                            Chapters and is expected to have over 1,50,000 visitors over the 6
                                            days period.
                                        </p>
                                        <p>
                                            India ITME 2026 will offer unmatched business to the exhibitors as
                                            the Indian textiles industry is set for strong growth, buoyed by
                                            strong domestic consumption as well as export demand. It will open
                                            windows to various business verticals in form of leads, contacts
                                            enquiries on a massive platform.
                                        </p>
                                        <p>
                                            Expected participation from 91 countries and 20 Chapters, making
                                            it as a one stop platform for the engineering solutions and
                                            technical technology for textile industry, servicing the whole of
                                            Indian textile industry and building India brand.
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-6 col-sm-6"
                                    data-aos="fade-left"
                                    data-aos-delay={300}
                                >
                                    <div className="position_relative f-right">
                                        <div className="about_img">
                                            <img
                                                src="assets/img/about_img.png"
                                                alt="Choose Us"
                                                loading="lazy"
                                            />
                                            <div className="triangle-down" />
                                            <div className="experience_year">
                                                <img src="assets/img/mark-about-counter.png" />
                                                <div className="d-flex align-items-center">
                                                    <h2>
                                                        12
                                                        <sup
                                                            style={{
                                                                textTransform: "capitalize",
                                                                fontStyle: "italic"
                                                            }}
                                                        >
                                                            th
                                                        </sup>
                                                    </h2>
                                                    <h3>
                                                        <span className="edition_text">Edition</span>
                                                    </h3>
                                                    {/* <h3>YEAR<br/>EXPERIENCE <span><span class="with_text">with</span><br/><span class="edition_text">12<sup>th</sup> Edition</span></span></h3> */}
                                                </div>
                                            </div>
                                            <a
                                                href="https://www.youtube.com/watch?v=KeHqurPa7d4"
                                                target="_blank"
                                                className="popup-video-link video-popup__button"
                                            >
                                                <i className="fas fa-play" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="Objective_Event" data-aos="fade-up" data-aos-delay={300}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <h1>Objective of the Event</h1>
                                    <div>
                                        <ul>
                                            <li>
                                                To develop India as a textile and textile engineering sourcing
                                                destination.
                                            </li>
                                            <li>
                                                To encourage investment in India for textile machinery
                                                manufacturing and thus support Government initiative to develop
                                                “India “as a manufacturing hub” for textile engineering.
                                            </li>
                                            <li>
                                                To encourage new market development to generate new custom lead
                                                from 2nd tire and rural markets for the manufacturers.
                                            </li>
                                            <li>
                                                To facilitate connect to agents, dealers, distributors for
                                                overseas market as well as the domestic market for the
                                                manufacturers.
                                            </li>
                                            <li>To facilitates joint ventures and technology transfer.</li>
                                            <li>
                                                To promote/support the growth of Textile Industry in India,
                                                through new technologies, along with Ancillary and Allied
                                                Industries &amp; Trade.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="chapters_section" data-aos="fade-up" data-aos-delay={300}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Chapters</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative">
                                                INDIA ITME 2026 CHAPTERS
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-6">
                                    <div className="chapters_accordion_div">
                                        <div
                                            className="accordion"
                                            id="accordionExample"
                                            data-aos="fade-left"
                                            data-aos-delay={600}
                                        >
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_1"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_1"
                                                    >
                                                        Chapter 1
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_1"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Machinery Of Spinning Preparatory, Man-made Fibre &amp;
                                                                Natural Fiber Spinning Machinery, Winding, Texturing,
                                                                Twisting And Related Auxiliary Machinery And
                                                                Accessories.
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_2"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_2"
                                                    >
                                                        Chapter 2
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_2"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Machinery Related To Technical Textiles And Accessories.
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_3"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_3"
                                                    >
                                                        Chapter 3
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_3"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Machinery For Weaving Preparatory , Weaving, Tufting,
                                                                Auxiliary And Accessories
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_4"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_4"
                                                    >
                                                        Chapter 4
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_4"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Knitting/ Hosiery Machinery, Auxiliary Machinery And
                                                                Accessories
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_5"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_5"
                                                    >
                                                        Chapter 5
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_5"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Embroidery Machinery, Braiding Machinery, Auxiliary
                                                                Machinery And Accessories{" "}
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_6"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_6"
                                                    >
                                                        Chapter 6
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_6"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Washing, Bleaching, Dyeing, Drying, Finishing Machinery,
                                                                And Related Auxiliary Machinery And Accessories
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_7"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_7"
                                                    >
                                                        Chapter 7
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_7"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Printing &amp; Digital Printing Machinery, And Related
                                                                Auxiliary Machinery &amp; Accessories
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_8"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_8"
                                                    >
                                                        Chapter 8
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_8"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Garment Making Machinery And Related Auxiliary Machinery
                                                                And Accessories
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_9"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_9"
                                                    >
                                                        Chapter 9
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_9"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Made-up Machinery And Related Auxiliary Machinery And
                                                                Accessories
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_10"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_10"
                                                    >
                                                        Chapter 10
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_10"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>Laboratory Testing And Measuring Equipment</p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="chapters_accordion_div">
                                        <div
                                            className="accordion"
                                            id="accordionExample"
                                            data-aos="fade-left"
                                            data-aos-delay={600}
                                        >
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_11"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_11"
                                                    >
                                                        Chapter 11
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_11"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Transportation, Material Handling, Storing And Packing
                                                                Equipment
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_12"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_12"
                                                    >
                                                        Chapter 12
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_12"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Equipment For Recycling, Waste Reduction And Pollution
                                                                Prevention, Accessories
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_13"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_13"
                                                    >
                                                        Chapter 13
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_13"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Software For Design, Data Monitoring And Processing (CAD
                                                                / CAM / CIM) And Integrated Production
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_14"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_14"
                                                    >
                                                        Chapter 14
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_14"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                ERP Pacakge &amp; Web Base Solution Textile Industry
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_15"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_15"
                                                    >
                                                        Chapter 15
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_15"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Dyestuffs And Chemical Products For The Textile Industry
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_16"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_16"
                                                    >
                                                        Chapter 16
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_16"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>Associated Goods And Services For The Textile</p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_17"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_17"
                                                    >
                                                        Chapter 17
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_17"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>Machinery Related To Engineering Products</p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_18"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_18"
                                                    >
                                                        Chapter 18
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_18"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Technical Information Services, Educational, Research
                                                                Institutes &amp; COE's
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_19"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_19"
                                                    >
                                                        Chapter 19
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_19"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>
                                                                Natural Fibres, Man-made Fibres, Technical Fibres,
                                                                Natural Yarns, Synthetic Yarns Technical Yarns And
                                                                Recycled Fibres And Yarns
                                                            </p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#Chapter_20"
                                                        aria-expanded="true"
                                                        aria-controls="Chapter_20"
                                                    >
                                                        Chapter 20
                                                    </button>
                                                </h2>
                                                <div
                                                    id="Chapter_20"
                                                    className="accordion-collapse show"
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="accordion-body">
                                                        <a href="index-of-product.html">
                                                            <p>Technical Textile Products</p>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>


                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(aboutItme));